import { Component, Input } from '@angular/core';
import { GlobalConstants } from 'src/app/services/global-constants';
import { NotificationHandlerService } from 'src/app/services/notification-handler.service';

@Component({
  selector: 'app-ou-info',
  templateUrl: './ou-info.component.html',
  styleUrl: './ou-info.component.scss'
})
export class OuInfoComponent {

  @Input() data: any;

  staticFileUrl: string = GlobalConstants.staticFilesURL;

  constructor( private notificationHandler: NotificationHandlerService ) {
  }

  ngOnInit() {
  }

  checkIsImage(img: string) {
    return this.notificationHandler.checkisImg(img);
  }

}
